module.exports = __webpack_public_path__ + "media/images/top/qa/img_fv-9dd58c9d3bf5110f2bd434103222f531.png";